import MouseTrap from 'mousetrap'
import type { ExtendedKeyboardEvent } from 'mousetrap'

/** Copied from `@types/mousetrap` */
type Keycode = string | string[]
type Handler = (event: ExtendedKeyboardEvent, combo: string) => boolean | void

export class HotKeyManager {
  mousetrap

  constructor() {
    this.mousetrap = new MouseTrap()
  }

  registerHotKey(keyCode: Keycode, handler: Handler): void {
    // A held key auto-repeats about ten times a second. Run the handler once
    // per key press so that a held key can't repeat an action, such as loading
    // a page of data, in a loop. Repeat events return the press's result so
    // that a handler that blocks the browser default still blocks it.
    let pressResult: boolean | void
    this.mousetrap.bind(
      keyCode,
      (event: ExtendedKeyboardEvent, combo: string) => {
        if (!event.repeat) pressResult = handler(event, combo)
        return pressResult
      }
    )
  }

  unregisterHotkey(keyCode: Keycode): void {
    this.mousetrap.unbind(keyCode)
  }
}

const hotKeyManagerInstance = new HotKeyManager()

export function registerHotKey(keyCode: Keycode, handler: Handler): void {
  hotKeyManagerInstance.registerHotKey(keyCode, handler)
}

export function unregisterHotKey(keyCode: Keycode): void {
  hotKeyManagerInstance.unregisterHotkey(keyCode)
}
